<template>
  <ul class="list-disc px-4 ml-4">
    <li>Anrede: {{ info }}</li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { formatChoice } from '@/utils/formatters/simpleChoice';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import { ANREDE_FIRMA } from '@/features/Clients';
import { useInputMappingStore } from '@/features/InputMapping/store';

const { getValue } = useInputMappingStore();

const info = computed(() => {
  const val = getValue('anredeId');

  if (val === undefined) {
    return '';
  }

  if (val === ANREDE_FIRMA) {
    return 'Firma';
  }

  return formatChoice(SIMPLE_CHOICE.SALUTATION)(val);
});
</script>
